import { render, staticRenderFns } from "./MinisterioDefesa.vue?vue&type=template&id=02f3ecda&scoped=true&"
import script from "./MinisterioDefesa.vue?vue&type=script&lang=js&"
export * from "./MinisterioDefesa.vue?vue&type=script&lang=js&"
import style0 from "./MinisterioDefesa.vue?vue&type=style&index=0&id=02f3ecda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f3ecda",
  null
  
)

export default component.exports